export default {
  userTokenState: state => state.userToken,
  userNameState: state => state.userName
}
